export const orderAmount = (order,locale='en-US') => {
  const taxFactor = 1+parseFloat(order.tax)/100
  let shippingCosts = parseFloat(order.shippingCosts || 0)
  let discount = parseFloat(order.discount || 0)
  if(order.gross) {
    shippingCosts /= taxFactor
    discount /= taxFactor
  }

  const nett = order.items.reduce((acc,cur) => {
    let value = parseFloat(cur.count || 1) * parseFloat(cur.price || 0)
    if(order.gross) value /= taxFactor
    return acc + value
  },0)

  const totalNett = nett + shippingCosts - discount

  const gross = nett * taxFactor
  const totalGross = totalNett * taxFactor
  const tax = totalGross - totalNett

  return {
    nett,
    gross,
    shippingCosts,
    discount,
    totalNett,
    totalGross,
    tax,

    nettHuman: Number(nett.toFixed(2)).toLocaleString(locale),
    grossHuman: Number(gross.toFixed(2)).toLocaleString(locale),
    shippingCostsHuman: Number(shippingCosts.toFixed(2)).toLocaleString(locale),
    discountHuman: Number(discount.toFixed(2)).toLocaleString(locale),
    totalNettHuman: Number(totalNett.toFixed(2)).toLocaleString(locale),
    totalGrossHuman: Number(totalGross.toFixed(2)).toLocaleString(locale),
    taxHuman: Number(tax.toFixed(2)).toLocaleString(locale)
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/share/order_helper.js